export class Carousel {
	element;
	wrapper;
	selectedIndex = 0;

	constructor(element, shuffle) {
		this.element = element;

		if(shuffle) {
			this.shuffle();
		}

		this.setup();
	}

	shuffle() {
		[...this.element.children].forEach(element => {
			let randomSibling = element.parentElement.children[Math.floor(Math.random() * element.parentElement.children.length)];
			element.parentElement.insertBefore(element, randomSibling);
		});
	}

	setup() {
		this.wrap();
		this.addButtons();
		this.select(0);
	}

	wrap() {
		this.wrapper = document.createElement("div");
		this.wrapper.classList.add("carousel-wrapper");
		this.element.parentElement.insertBefore(this.wrapper, this.element);
		this.wrapper.appendChild(this.element);
	}

	addButtons() {
		let prevButton = document.createElement("button");
		prevButton.classList.add("prev");
		prevButton.textContent = "◀";
		let nextButton = document.createElement("button");
		nextButton.classList.add("next");
		nextButton.textContent = "▶";
		this.element.after(prevButton, nextButton);

		prevButton.addEventListener("click", e => {
			this.select(this.selectedIndex - 1);
		});
		nextButton.addEventListener("click", e => {
			this.select(this.selectedIndex + 1);
		});
	}

	select(index) {
		if(index < 0) {
			index += this.element.children.length;
		}
		if(index > this.element.children.length - 1) {
			index -= this.element.children.length;
		}

		[...this.element.children].forEach(element => {
			element.hidden = true;
		});
		this.element.children[index].hidden = false;

		this.selectedIndex = index;
	}
}
